export const lastShownKey = "onpage_dialog_last_shown";
export const coolDownPeriodKey = "onpage_dialog_cool_down";
export var ShowOnpageDialogResult;
(function (ShowOnpageDialogResult) {
    ShowOnpageDialogResult[ShowOnpageDialogResult["ignored"] = 0] = "ignored";
    ShowOnpageDialogResult[ShowOnpageDialogResult["rejected"] = 1] = "rejected";
    ShowOnpageDialogResult[ShowOnpageDialogResult["shown"] = 2] = "shown";
    ShowOnpageDialogResult[ShowOnpageDialogResult["error"] = 3] = "error";
})(ShowOnpageDialogResult || (ShowOnpageDialogResult = {}));
